import React from "react";
import { displayDate } from "@/lib/evidencePresentation";

export default function ReportCoverage({ report, metrics: presentedMetrics }) {
  const metrics = presentedMetrics || report.evidence.metrics || [];
  const sourced = metrics.filter((m) => m.status === "observed").length;
  const older = metrics.filter((m) => m.status === "stale").length;
  const missing = metrics.filter((m) => m.status === "unavailable").length;
  const inputs = metrics.filter((m) =>
    ["user_provided", "assumed", "calculated"].includes(m.status),
  ).length;
  const matched = report.coverage?.status === "address_matched";
  return (
    <section className="coverage-strip" aria-label="Report coverage">
      <div>
        <span className="eyebrow">Address check</span>
        <strong>
          {matched
            ? report.coverage.cached ||
              report.evidence.location?.status === "stale"
              ? "Match needs revalidation"
              : "Council record matched"
            : "Address unverified"}
        </strong>
        <small>Prepared {displayDate(report.prepared_at)}</small>
      </div>
      <div>
        <strong>{sourced}</strong>
        <span>Sourced findings</span>
      </div>
      <div>
        <strong>{older}</strong>
        <span>Older findings</span>
      </div>
      <div>
        <strong>{missing}</strong>
        <span>Unassessed items</span>
      </div>
      <p>
        {inputs} input or scenario item{inputs === 1 ? "" : "s"}, separate from
        sourced evidence. These counts describe data availability, not property
        safety or report completeness.
      </p>
    </section>
  );
}
